<template>
  <div class="footer-background pt-0">
    <slot>
      <!-- <div class="action">
        <h4 class="use-text-title2">
          <span v-t="'copy.footerHeadline'" />
        </h4>
        <v-btn color="secondary" large>
          <span v-t="'Get Started'" />
        </v-btn>
      </div> -->
    </slot>
    <footer-minimal />
  </div>
</template>

<style lang="scss" scoped>
@import "./footer-style.scss";
</style>

<script>
import FooterMinimal from "./FooterMinimal";
import Footer from "./Footer";

export default {
  components: {
    "footer-main": Footer,
    FooterMinimal,
  },
};
</script>
